import { Box, Paper } from "@mui/material";
import { KboFlowRunOutput } from "../KboFlowDebug/KboFlowRunDebug";
import { StatusPill } from "./KboFlowRunDetailPrimitives";
import {
    DigestQuestion,
    questionStatus,
    shortQuestionLabel,
} from "./KboFlowRunDigestModels";
import { kboFlowRunDetailColors as pageColors } from "./KboFlowRunDetailStyles";

export function RunNavigation({
    output,
    questions,
    selectedQuestionId,
    onSelect,
}: {
    output: KboFlowRunOutput;
    questions: DigestQuestion[];
    selectedQuestionId?: string;
    onSelect: (questionId?: string) => void;
}) {
    return (
        <Paper
            variant="outlined"
            sx={{
                borderRadius: 2,
                display: "flex",
                gap: 0.5,
                overflowX: "auto",
                p: 0.75,
            }}
        >
            <Box
                component="button"
                type="button"
                onClick={() => onSelect()}
                sx={{
                    bgcolor: "transparent",
                    border: 0,
                    borderBottom: "3px solid",
                    borderColor: !selectedQuestionId
                        ? pageColors.blue
                        : "transparent",
                    color: pageColors.ink,
                    cursor: "pointer",
                    flex: "0 0 auto",
                    font: "inherit",
                    fontSize: 14,
                    fontWeight: 750,
                    px: 2,
                    py: 1.25,
                }}
            >
                Whole run
            </Box>
            {questions.map((question, index) => {
                const active = selectedQuestionId === question.id;
                return (
                    <Box
                        key={question.id ?? index}
                        component="button"
                        type="button"
                        onClick={() => onSelect(question.id)}
                        sx={{
                            alignItems: "center",
                            bgcolor: "transparent",
                            border: 0,
                            borderBottom: "3px solid",
                            borderColor: active
                                ? pageColors.blue
                                : "transparent",
                            color: pageColors.ink,
                            cursor: "pointer",
                            display: "flex",
                            flex: "0 0 auto",
                            font: "inherit",
                            fontSize: 14,
                            fontWeight: 700,
                            gap: 0.75,
                            px: 1.5,
                            py: 1.25,
                        }}
                    >
                        Q{index + 1} · {shortQuestionLabel(question)}
                        <StatusPill status={questionStatus(output, question)} />
                    </Box>
                );
            })}
        </Paper>
    );
}
